// Google Ads conversion tracking utility

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    gtag_report_conversion: (url?: string) => boolean;
    gtag_report_conversion_call: (url?: string) => boolean;
  }
}

/**
 * Track phone call conversion using gtag_report_conversion_call
 * Use this function when a user clicks on a phone number link
 * This uses a specific conversion ID for phone call clicks
 */
export const trackPhoneCall = (phoneNumber?: string) => {
  if (typeof window !== 'undefined' && window.gtag_report_conversion_call) {
    window.gtag_report_conversion_call();
  }
};

/**
 * Track WhatsApp conversion using gtag_report_conversion
 * Use this function when a user clicks on a WhatsApp link
 */
export const trackWhatsApp = () => {
  if (typeof window !== 'undefined' && window.gtag_report_conversion) {
    window.gtag_report_conversion();
  }
};

/**
 * Track form submission conversion - call this on thank you page
 * This should be called when the user reaches the thank you page after submitting the form
 */
export const trackFormSubmission = () => {
  if (typeof window !== 'undefined' && window.gtag_report_conversion) {
    window.gtag_report_conversion();
  }
};

/**
 * Track custom event
 */
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

